import { Component } from '@angular/core';
import BaseQuestion from '../base-question';
import { FeedbackQuestionService } from '../feedback-question.service';
import { FeedbackQuestion } from "../../../common/models/feedback-question";
import { FeedbackBorgAnswerComponent } from "../../answers/borg";

@Component({
  selector: 'app-feedback-borg-question',
  templateUrl: 'feedback-borg-question.component.html',
  standalone: true,
  imports: [
    FeedbackBorgAnswerComponent
  ],
  styleUrls: ['./../feedback-question.css']
})
export class FeedbackBorgQuestionComponent extends BaseQuestion {
    public static type = FeedbackQuestion.TYPE_BORG;

    constructor(feedbackQuestionService: FeedbackQuestionService) {
        super(feedbackQuestionService);
    }
}
